import {
  Button,
  createTheme,
  Menu,
  Modal,
  Popover,
  rem,
  Tooltip,
  virtualColor,
} from "@mantine/core";
import { SA_SHADOWS } from "../tokens/effects";

export const superAgentsTheme = createTheme({
  primaryColor: "R500",
  colors: {
    L100: [
      "#FFFFFF",
      "#FFFFFF",
      "#FFFFFF",
      "#FFFFFF",
      "#FFFFFF",
      "#FFFFFF",
      "#FFFFFF",
      "#FFFFFF",
      "#FFFFFF",
      "#FFFFFF",
    ],
    L200: [
      "#F1F1F1",
      "#F1F1F1",
      "#F1F1F1",
      "#F1F1F1",
      "#F1F1F1",
      "#F1F1F1",
      "#F1F1F1",
      "#F1F1F1",
      "#F1F1F1",
      "#F1F1F1",
    ],
    L300: [
      "#EAEAEA",
      "#EAEAEA",
      "#EAEAEA",
      "#EAEAEA",
      "#EAEAEA",
      "#EAEAEA",
      "#EAEAEA",
      "#EAEAEA",
      "#EAEAEA",
      "#EAEAEA",
    ],
    L500: [
      "#E0E0E0",
      "#E0E0E0",
      "#E0E0E0",
      "#E0E0E0",
      "#E0E0E0",
      "#E0E0E0",
      "#E0E0E0",
      "#E0E0E0",
      "#E0E0E0",
      "#E0E0E0",
    ],
    L600: [
      "#CFCFCF",
      "#CFCFCF",
      "#CFCFCF",
      "#CFCFCF",
      "#CFCFCF",
      "#CFCFCF",
      "#CFCFCF",
      "#CFCFCF",
      "#CFCFCF",
      "#CFCFCF",
    ],
    L700: [
      "#AFAFAF",
      "#AFAFAF",
      "#AFAFAF",
      "#AFAFAF",
      "#AFAFAF",
      "#AFAFAF",
      "#AFAFAF",
      "#AFAFAF",
      "#AFAFAF",
      "#AFAFAF",
    ],
    L750: [
      "#7F7D7D",
      "#7F7D7D",
      "#7F7D7D",
      "#7F7D7D",
      "#7F7D7D",
      "#7F7D7D",
      "#7F7D7D",
      "#7F7D7D",
      "#7F7D7D",
      "#7F7D7D",
    ],
    L800: [
      "#929292",
      "#929292",
      "#929292",
      "#929292",
      "#929292",
      "#929292",
      "#929292",
      "#929292",
      "#929292",
      "#929292",
    ],
    L900: [
      "#3E3E3E",
      "#3E3E3E",
      "#3E3E3E",
      "#3E3E3E",
      "#3E3E3E",
      "#3E3E3E",
      "#3E3E3E",
      "#3E3E3E",
      "#3E3E3E",
      "#3E3E3E",
    ],
    D300: [
      "#3D3C55",
      "#3D3C55",
      "#3D3C55",
      "#3D3C55",
      "#3D3C55",
      "#3D3C55",
      "#3D3C55",
      "#3D3C55",
      "#3D3C55",
      "#3D3C55",
    ],
    D400: [
      "#5C5C6C",
      "#5C5C6C",
      "#5C5C6C",
      "#5C5C6C",
      "#5C5C6C",
      "#5C5C6C",
      "#5C5C6C",
      "#5C5C6C",
      "#5C5C6C",
      "#5C5C6C",
    ],
    D450: [
      "#6C6B83",
      "#6C6B83",
      "#6C6B83",
      "#6C6B83",
      "#6C6B83",
      "#6C6B83",
      "#6C6B83",
      "#6C6B83",
      "#6C6B83",
      "#6C6B83",
    ],
    D500: [
      "#181737",
      "#181737",
      "#181737",
      "#181737",
      "#181737",
      "#181737",
      "#181737",
      "#181737",
      "#181737",
      "#181737",
    ],
    D600: [
      "#2A2941",
      "#2A2941",
      "#2A2941",
      "#2A2941",
      "#2A2941",
      "#2A2941",
      "#2A2941",
      "#2A2941",
      "#2A2941",
      "#2A2941",
    ],
    D700: [
      "#0B0A29",
      "#0B0A29",
      "#0B0A29",
      "#0B0A29",
      "#0B0A29",
      "#0B0A29",
      "#0B0A29",
      "#0B0A29",
      "#0B0A29",
      "#0B0A29",
    ],
    D900: [
      "#05041E",
      "#05041E",
      "#05041E",
      "#05041E",
      "#05041E",
      "#05041E",
      "#05041E",
      "#05041E",
      "#05041E",
      "#05041E",
    ],
    P900: [
      "#140248",
      "#140248",
      "#140248",
      "#140248",
      "#140248",
      "#140248",
      "#140248",
      "#140248",
      "#140248",
      "#140248",
    ],
    R300: [
      "#9E7FFF",
      "#9E7FFF",
      "#9E7FFF",
      "#9E7FFF",
      "#9E7FFF",
      "#9E7FFF",
      "#9E7FFF",
      "#9E7FFF",
      "#9E7FFF",
      "#9E7FFF",
    ],
    R500: [
      "#6734FF",
      "#6734FF",
      "#6734FF",
      "#6734FF",
      "#6734FF",
      "#6734FF",
      "#6734FF",
      "#6734FF",
      "#6734FF",
      "#6734FF",
    ],
    R600: [
      "#4D26BF",
      "#4D26BF",
      "#4D26BF",
      "#4D26BF",
      "#4D26BF",
      "#4D26BF",
      "#4D26BF",
      "#4D26BF",
      "#4D26BF",
      "#4D26BF",
    ],
    R700: [
      "#33187F",
      "#33187F",
      "#33187F",
      "#33187F",
      "#33187F",
      "#33187F",
      "#33187F",
      "#33187F",
      "#33187F",
      "#33187F",
    ],
    V300: [
      "#F68577",
      "#F68577",
      "#F68577",
      "#F68577",
      "#F68577",
      "#F68577",
      "#F68577",
      "#F68577",
      "#F68577",
      "#F68577",
    ],
    V500: [
      "#F5452E",
      "#F5452E",
      "#F5452E",
      "#F5452E",
      "#F5452E",
      "#F5452E",
      "#F5452E",
      "#F5452E",
      "#F5452E",
      "#F5452E",
    ],
    V700: [
      "#761F15",
      "#761F15",
      "#761F15",
      "#761F15",
      "#761F15",
      "#761F15",
      "#761F15",
      "#761F15",
      "#761F15",
      "#761F15",
    ],
    A300: [
      "#D9E287",
      "#D9E287",
      "#D9E287",
      "#D9E287",
      "#D9E287",
      "#D9E287",
      "#D9E287",
      "#D9E287",
      "#D9E287",
      "#D9E287",
    ],
    A500: [
      "#C2D600",
      "#C2D600",
      "#C2D600",
      "#C2D600",
      "#C2D600",
      "#C2D600",
      "#C2D600",
      "#C2D600",
      "#C2D600",
      "#C2D600",
    ],
    A700: [
      "#4E5600",
      "#4E5600",
      "#4E5600",
      "#4E5600",
      "#4E5600",
      "#4E5600",
      "#4E5600",
      "#4E5600",
      "#4E5600",
      "#4E5600",
    ],
    Y300: [
      "#FBBF24",
      "#FBBF24",
      "#FBBF24",
      "#FBBF24",
      "#FBBF24",
      "#FBBF24",
      "#FBBF24",
      "#FBBF24",
      "#FBBF24",
      "#FBBF24",
    ],
    Y700: [
      "#B45309",
      "#B45309",
      "#B45309",
      "#B45309",
      "#B45309",
      "#B45309",
      "#B45309",
      "#B45309",
      "#B45309",
      "#B45309",
    ],
    background_4: virtualColor({
      name: "background_4",
      dark: "D900",
      light: "L200",
    }),
    background_3: virtualColor({
      name: "background_3",
      dark: "D900",
      light: "L100",
    }),
    background_2: virtualColor({
      name: "background_2",
      dark: "D700",
      light: "L500",
    }),
    background_1: virtualColor({
      name: "background_1",
      dark: "D500",
      light: "L300",
    }),
    plain_text: virtualColor({
      name: "plain_text",
      dark: "L300",
      light: "D900",
    }),
    contrast_text: virtualColor({
      name: "contrast_text",
      dark: "R500",
      light: "R500",
    }),
    contrast_text_darker: virtualColor({
      name: "contrast_text_darker",
      dark: "R600",
      light: "R600",
    }),
    /* Pendência de configuração ("defina quando enviar"): atenção, não erro.
       V500 (vermelho) diz "falhou"; o âmbar diz "falta você preencher". No claro
       o Y700 dá 5,0:1 sobre o card branco; no escuro o Y300 dá 11:1 sobre D900. */
    warning_text: virtualColor({
      name: "warning_text",
      dark: "Y300",
      light: "Y700",
    }),
    text_with_colorful_bg: virtualColor({
      name: "text_with_colorful_bg",
      dark: "L300",
      light: "L300",
    }),
    list_item_text: virtualColor({
      name: "list_item_text",
      dark: "L100",
      light: "R500",
    }),
    /* Link dentro de conteúdo (mensagem de chat). No claro o roxo da marca sobre
       a bolha clara dá 4,97:1; no escuro o mesmo roxo cairia para 2,88:1 sobre
       a bolha D500, então o tom claro (R300) assume e volta para 5,69:1. */
    link_text: virtualColor({
      name: "link_text",
      dark: "R300",
      light: "R500",
    }),
    disabled_element: virtualColor({
      name: "disabled_element",
      dark: "D400",
      light: "L800",
    }),
    button_close_background: virtualColor({
      name: "button_close_background",
      light: "L900",
      dark: "D300",
    }),
    disabled_input_background: virtualColor({
      name: "disabled_input_background",
      light: "L600",
      dark: "D600",
    }),
    disabled_input_text: virtualColor({
      name: "disabled_input_text",
      light: "L750",
      dark: "D450",
    }),
  },
  fontFamily: "Mulish, sans-serif",
  fontFamilyMonospace: "Monaco, Courier, monospace",
  headings: {
    fontFamily: "Outfit, sans-serif",
    fontWeight: "700",
    sizes: {
      h1: { fontSize: rem(40) },
      h2: { fontSize: rem(32) },
      h3: { fontSize: rem(24) },
      h4: { fontSize: rem(20) },
      h5: { fontSize: rem(16) },
      h6: { fontSize: rem(12) },
    },
  },
  fontSizes: {
    xs: rem(11),
    sm: rem(12),
    md: rem(14),
    lg: rem(16),
    xl: rem(20),
  },
  breakpoints: {
    sm: "768px",
  },
  /* Raios do DS (docs/design-system/tokens/spacing.css). Só `lg` diverge do
     padrão do Mantine (16 → 12: popovers, cards e blocos). `xl` fica em 32
     porque ~100 chamadas usam `radius="xl"` como pílula. */
  radius: {
    xs: rem(2),
    sm: rem(4),
    md: rem(8),
    lg: rem(12),
    xl: rem(32),
  },
  /* Sombras do DS: difusas e sempre em D900 com alfa, nunca preto puro. `md` é a
     de popover (é o que `shadow="md"` significa no código) e `xl` a de modal,
     que é o padrão do Modal do Mantine. */
  shadows: {
    xs: SA_SHADOWS.knob,
    sm: SA_SHADOWS.segment,
    md: SA_SHADOWS.popover,
    lg: SA_SHADOWS.sheet,
    xl: SA_SHADOWS.dialog,
  },
  components: {
    /* Botão pelo DS (components/core/Button.jsx).
       - Rótulo: 36px de altura com 14px de texto, 30px com 12px. O Mantine liga a
         fonte ao `size` (sm = 12px neste tema), então todo botão padrão saía 2px
         menor que o design.
       - Hover: o Mantine escurece para o tom seguinte da cor, e as nossas cores
         têm os 10 tons iguais, então o primário não reagia ao mouse. O DS pede
         R600; no destrutivo, `--sa-danger-fill-hover` (o mesmo passo do
         primário, ver o resolver); no contorno, a cor em 8%; no ghost,
         `--sa-hover`.
       - Transição: o Mantine troca o fundo sem transição e o hover "pulava"; o
         DS anima o fundo em `--sa-dur-fast`. */
    Button: Button.extend({
      styles: {
        root: {
          transition:
            "background-color var(--sa-dur-fast) var(--sa-ease), color var(--sa-dur-fast) var(--sa-ease)",
        },
      },
      vars: (_theme, props) => {
        const root: Record<string, string> = {};
        if (props.size === "xs") root["--button-fz"] = rem(12);
        if (props.size === undefined || props.size === "sm") {
          root["--button-fz"] = rem(14);
        }
        if (props.variant === undefined || props.variant === "filled") {
          if (props.color === undefined || props.color === "R500") {
            root["--button-hover"] = "var(--mantine-color-R600-0)";
          }
          if (props.color === "V500") {
            root["--button-hover"] = "var(--sa-danger-fill-hover)";
          }
        }
        // Contorno e ghost também reagem ao mouse (DS: tom da cor em 8% e
        // `--sa-hover`); o Mantine deixava os dois sem hover nenhum.
        if (props.variant === "outline") {
          root["--button-hover"] =
            props.color === "V500"
              ? "color-mix(in srgb, var(--mantine-color-V500-0) 8%, transparent)"
              : "var(--sa-brand-tint-weak)";
        }
        if (props.variant === "transparent") {
          root["--button-hover"] = "var(--sa-hover)";
        }
        return { root };
      },
    }),
    Tooltip: Tooltip.extend({
      defaultProps: { color: "P900", radius: "md" },
      styles: {
        tooltip: {
          color: "var(--mantine-color-text_with_colorful_bg-0)",
          fontWeight: 600,
          boxShadow: SA_SHADOWS.tooltip,
        },
      },
    }),
    Popover: Popover.extend({
      defaultProps: { radius: "lg", shadow: "md" },
    }),
    Menu: Menu.extend({
      defaultProps: { radius: "lg", shadow: "md" },
      styles: { item: { borderRadius: rem(8) } },
    }),
    Modal: Modal.extend({
      defaultProps: {
        radius: rem(14),
        /* Token, não nome de cor: o Overlay passa `color` pelo `rgba()` do
           Mantine, que não resolve "D900" (viraria preto) e transforma a
           CSS var em `color-mix`. */
        overlayProps: {
          color: "var(--mantine-color-D900-0)",
          backgroundOpacity: 0.45,
        },
      },
    }),
  },
  other: {
    gradients: {
      expiredImage: {
        incoming: {
          light: "linear-gradient(to left, #E0E0E0 0%, #AFAFAF 100%)",
          dark: "linear-gradient(to right, #2B2A3F 0%, #17162F 100%)",
        },
        outgoing: {
          light: "linear-gradient(to right, #9E7FFF 0%, #6734FF 100%)",
          dark: "linear-gradient(to left, #6734FF 0%, #33187F 100%)",
        },
      },
    },
  },
});
